import { inject, Injectable } from '@angular/core';
import { AuditService } from '../data-access/src/lib/audit/audit.service';
import { CloudService } from '../data-access/src/lib/cloud/cloud.service';
import { DashboardService } from '../data-access/src/lib/dashboard/dashboard.service';
import { IngestProjectService } from '../data-access/src/lib/ingest/ingest-project.service';
import { LegalHoldService } from '../data-access/src/lib/legal-hold/legal-hold.service';
import { NotificationsService } from '../data-access/src/lib/notifications/notifications.service';
import { PreservationMessagesService } from '../data-access/src/lib/preservation-messages/preservation-messages.service';
import { PreservationService } from '../data-access/src/lib/preservation/preservation.service';
import { ProfileService } from '../data-access/src/lib/profile/profile.service';
import { RepositoryService } from '../data-access/src/lib/repository/repository.service';
import { ReportsService } from '../data-access/src/lib/reports/reports.service';
import { RetentionPolicyService } from '../data-access/src/lib/retention/retention-policy.service';
import { DocumentRetentionService } from '../data-access/src/lib/retention/document-retention.service';

/**
 * Punto de entrada de alto nivel para consumidores de `@nebula/vault` (p. ej. nebula-erp)
 * sin importar múltiples servicios a la vez.
 */
@Injectable({ providedIn: 'root' })
export class VaultFacade {
  readonly audit = inject(AuditService);
  readonly cloud = inject(CloudService);
  readonly dashboard = inject(DashboardService);
  readonly documentRetention = inject(DocumentRetentionService);
  readonly ingestProjects = inject(IngestProjectService);
  readonly legalHold = inject(LegalHoldService);
  readonly notifications = inject(NotificationsService);
  readonly preservationMessages = inject(PreservationMessagesService);
  readonly preservation = inject(PreservationService);
  readonly profile = inject(ProfileService);
  readonly repository = inject(RepositoryService);
  readonly reports = inject(ReportsService);
  readonly retentionPolicies = inject(RetentionPolicyService);
}
